import { BASE_URL, userRequest, COMBO_URL, publicRequest } from "../requestMethods";
import {
    getCategoryStart, getCategorySuccess, getCategoryFailure
} from "../redux/categoryRedux";

import {
    getSubCategoryStart, getSubCategorySuccess, getSubCategoryFailure
} from "../redux/subcategoryRedux";

import { toast } from "react-toastify";

export const fetchCategories = async (dispatch) => {
    dispatch(getCategoryStart());
    try {
        const res = await userRequest.get(
            `${COMBO_URL}combosCategory/getActiveCategory`
        );

        if (res.status === 200) {
            console.log(res.data, "res.data for categories");
            dispatch(getCategorySuccess(res.data.data));
        }
    } catch (err) {
        dispatch(getCategoryFailure());
    }
};


export const fetchSubcategoriesByCategoryId = async (dispatch, id) => {
    dispatch(getSubCategoryStart());
    try {
        const res = await publicRequest.post(
            `${COMBO_URL}combosSubCategory/getActiveSubcategory/byCategory/${id}`
        );
        console.log(res, "fetch cat");
        if (res.status === 200) {
            dispatch(getSubCategorySuccess(res.data.data));
        }
        return res.data.data
    } catch (err) {
        console.log(err, 'err at fetch subcategories platform')
        dispatch(getSubCategoryFailure());

    }
};